import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, Loader2, ArrowRight } from "lucide-react";
import { fetchMyEscrows } from "@/lib/api";
import { fmtPrice, withWatermark } from "@/lib/utils";
import AccountSidebar from "@/components/AccountSidebar";
import { ESCROW_STATUS } from "@/pages/EscrowStatusPage";

export default function MesTransactionsPage() {
  const [items, setItems] = useState(null);
  useEffect(() => { fetchMyEscrows().then(setItems).catch(() => setItems([])); }, []);

  return (
    <main className="max-w-7xl mx-auto px-6 py-10" data-testid="mes-transactions-page">
      <h1 className="font-display text-4xl md:text-5xl font-extrabold tracking-tight inline-flex items-center gap-3"><ShieldCheck className="text-emerald-600" size={36} /> Paiements securises</h1>
      <p className="text-[var(--ink-soft)] mt-2">Vos achats et ventes proteges par le sequestre Fodindin : le vendeur est paye apres confirmation de reception.</p>
      <div className="mt-8 grid grid-cols-1 lg:grid-cols-[260px_1fr] gap-6">
        <AccountSidebar />
        <section>
          {items === null ? <Loader2 className="animate-spin text-emerald-600" /> : items.length === 0 ? (
            <div className="glass-card p-8 text-center text-sm text-[var(--ink-soft)]" data-testid="escrows-empty">
              Aucune transaction securisee pour l&apos;instant. Sur une annonce, cliquez « Acheter en paiement securise ».
              <div className="mt-4"><Link to="/annonces" className="btn-primary">Voir les annonces</Link></div>
            </div>
          ) : (
            <ul className="space-y-3" data-testid="escrows-list">
              {items.map((e) => {
                const st = ESCROW_STATUS[e.status] || { label: e.status, cls: "" };
                return (
                  <li key={e.ref}>
                    <Link to={`/escrow/${e.ref}`} className="glass-card p-4 flex items-center gap-4 hover:shadow-lg transition-shadow" data-testid={`escrow-row-${e.ref}`}>
                      {e.annonce_image && <img src={withWatermark(e.annonce_image)} alt="" className="w-16 h-16 rounded-xl object-cover" />}
                      <div className="flex-1 min-w-0">
                        <div className="font-bold truncate">{e.annonce_title}</div>
                        <div className="text-xs text-[var(--ink-soft)]">{e.role === "buyer" ? "Achat" : "Vente"} · {e.ref} · {new Date(e.created_at).toLocaleDateString("fr-FR")}</div>
                        <span className={`inline-block mt-1 text-[11px] font-bold px-2 py-0.5 rounded-full border ${st.cls}`}>{st.label}</span>
                      </div>
                      <div className="text-right">
                        <div className="font-bold text-emerald-700">{fmtPrice(e.role === "seller" ? e.seller_amount : e.amount)}</div>
                        <ArrowRight size={16} className="ml-auto text-[var(--ink-soft)]" />
                      </div>
                    </Link>
                  </li>
                );
              })}
            </ul>
          )}
        </section>
      </div>
    </main>
  );
}
